import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import TradingCalendar from "./TradingCalendar";
import { getCalendar } from "../services/api";

function CalendarPage() {
  const [calendarDays, setCalendarDays] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());

  function getMonthString(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  }

  useEffect(() => {
    async function loadCalendar() {
      try {
        const monthString = getMonthString(currentDate);
        const data = await getCalendar(monthString);
        setCalendarDays(data.days || []);
      } catch (err) {}
    }

    loadCalendar();
  }, [currentDate]);

  return (
    <div className="app-shell">
      <Sidebar />
      <main className="main-content-area">
        <div className="page-header">
          <div>
            <h1 className="page-title">Calendar</h1>
            <p className="page-subtitle">View your trading performance by day and week.</p>
          </div>
        </div>

        <TradingCalendar
          currentDate={currentDate}
          setCurrentDate={setCurrentDate}
          calendarDays={calendarDays}
          selectedDate=""
          onDayClick={() => {}}
        />
      </main>
    </div>
  );
}

export default CalendarPage;